import PropTypes from 'prop-types';

export const props = {
  t: PropTypes.func,
  show: PropTypes.bool,
  closeModal: PropTypes.func,
  item: PropTypes.object,
  handleGetUserBookings: PropTypes.func,
};
